<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="table-wrap"
    >
      <el-table-column
        prop="sort"
        label="序号"
        width="60"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="member_name"
        label="会员名称"
        width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="member_discount"
        label="享受折扣（折）"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="pay_num"
        label="出售数量"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <div class="operation-wrap">
            <span
              v-if="operations.includes('VIP规格')"
              class="operation-item"
              @click="handleOperationClick('spec', scope.row)"
            >规格</span>
            <span
              v-if="operations.includes('编辑VIP')"
              class="operation-item"
              @click="handleOperationClick('edit', scope.row)"
            >编辑</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <common-dialog
      title="编辑VIP"
      :dialogVisible="dialogVisible"
      @cancel="dialogVisible = false"
      @confirm="dialogConfirmClick"
      @dialog-close="dialogClose"
    >
      <div>
        <div class="input-wrap">
          <label>排序序号:</label>
          <el-input
            v-model="info.sort"
            placeholder="请输入排序序号"
            class="input"
          ></el-input>
        </div>
        <div class="input-wrap">
          <label>VIP名称:</label>
          <el-input
            v-model="info.member_name"
            placeholder="请输入VIP名称"
            class="input"
          ></el-input>
        </div>
        <div class="input-wrap">
          <label>享受折扣:</label>
          <el-input
            v-model="info.member_discount"
            placeholder="请输入折扣"
            class="input"
          ><template slot="append">折</template></el-input>
        </div>
      </div>
    </common-dialog>
  </div>
</template>

<script>
import { getMemberList, editMember} from '@/api/member-setting';
import CommonDialog from '@/components/CommonDialog';
import operations from '@/mixins/operations';

export default {
  name: 'blank',
  mixins: [operations],
  data() {
    return {
      keyword_search: '',
      tableData: [],
  		page_index: '1',  //第几页
  		page_size: '10',
      total: 0, //总条数
      dialogVisible: false,
  		info: {},
  		dialogType: '',
    }
  },
  components:{
    CommonDialog
  },
  mounted(){
    this._getMemberList()
  },
  computed:{},
  methods:{
    handlerSerial(index) {
      return (this.page_index - 1) * this.page_size + (index + 1);
    },
    async _getMemberList() {
      const { status, data } = await getMemberList();
      if (status === 200 ) {
        data.forEach( item => {
          item.member_discount = item.member_discount * 10;
        })
        this.tableData = data;
      }
    },
    async dialogConfirmClick() {
      const { sort, member_name, member_discount } = this.info;
      if (!sort) {
        this.$message('请输入序号')
        return
      }
      if (!member_name) {
        this.$message('请输入名称')
        return
      }
      if (!member_discount) {
        this.$message('请输入折扣')
        return
      }
      if (isNaN(member_discount)) {
        this.$message('折扣必须为数字')
        return
      }
      if (+member_discount < 1) {
        this.$message('折扣不能小于1')
        return
      }
      this.info.member_discount = member_discount / 10
      const { status } = await editMember(this.info);
      if ( status === 200 ) {
        this.dialogVisible = false;
      }
    },
    dialogClose() {
      this.dialogVisible = false;
      this._getMemberList();
    },
    handleOperationClick(type, row) {
      switch(type) {
        case 'edit':
          this.dialogVisible = true;
          this.info = JSON.parse(JSON.stringify(row));
          break;
        case 'spec':
          this.$router.push({
            path: '/member-spec',
            query: {
              uuid: row.uuid,
              name: row.member_name
            }
          })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/mixins.less';

.input-wrap {
  margin-bottom: 20px;
  label {
    display: block;
    margin-bottom: 10px;
  }
  .input {
    max-width: 300px;
    margin-right: 20px;
  }
}
.table-wrap {
  .table-wrap();
}
</style>
